import React from "react";
import { Link } from "react-router-dom";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";

export default function StoryCanvas() {
  return (
    <div className="Gallery-Wraps-2 retouching Canvases">
      <main>
        {/* hera banner start */}
        <div
          className="tp-breadcrumb__area fix tp-breadcrumb-height"
          data-background="assets/img/breadcrumb/Canvases.png"
          style={{
            backgroundImage: 'url("assets/img/breadcrumb/Canvases.png")',
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="tp-breadcrumb__content text-center z-index-5">
                  <h3 className="tp-breadcrumb__title">
                    Story Canvases <br />
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* hero banner end */}
        {/* second content section start*/}
        <section className="parent">
          <section
            className=" pb-100 Partener photographs"
            data-background="assets/img/breadcrumb/routing.png"
            style={{ backgroundImage: 'url("assets/img/breadcrumb/routing.png")', backgroundSize: "cover" }}
          >
            <div className="container">
              <div className="row ">
                <div className="row text text-center pt-50">
                  <div className="col-xl-12 col-lg-12 col-md-12 text-center ">
                    <h4 className="text-left second">
                      Create Your <br /> Story Canvas
                    </h4>
                    <p className="w-50">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Integer non ante eget nulla efficitur elementum. Donec
                      aliquam dignissim eros non pharetra. Praesent velit massa,
                      iaculis sit amet risus ut, maximus cursus tortor.
                      Suspendisse in dui sed massa vestibulum consequat.
                      Suspendisse at erat eu magna congue pretium et ut nunc.
                    </p>
                  </div>
                </div>
                <div
                  className="col-xl-8 col-lg-12 col-md-12 text-center m-auto pt-30"
                  style={{ zIndex: 9 }}
                >
                  <div className=" ">
                    <img
                      className="w-32"
                      src="assets/img/blog/story-canvas.png"
                      alt=""
                    />
                  </div>
                </div>
                <div className="text-center mt-60 button-uper">
                  <Link className="  large head banner"  >
                    Create STORY CANVAS
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* second content section end */}
       
        <UpperFooterSlider />
      </main>
    </div>
  );
}
